<template>
    <form class="form-horizontal" v-if="config">

        <div class="form-group">

            <label for="dpa_base_speed" class="col-sm-2 control-label">LIMITE DE VELOCIDADE:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.svc_speed_limit" class="form-control input-sm" id="dpa_base_speed">
            </div>
            <label for="svc_tipo_conexao" class="col-sm-2 control-label">TIPO DE CONEXÃO:</label>
            <div class="col-sm-4">
                <select v-model="config.svc_tipo_conexao" class="form-control" id="svc_tipo_conexao">
                    <option :value="0">MANTER CONEXÃO GPRS</option>
                    <option :value="1">FECHAR CONEXÃO GPRS</option>
                </select>
            </div>
        </div>

        <div class="form-group">

            <label for="svc_sensor_movimento" class="col-sm-2 control-label">SENSOR DE MOVIMENTO:</label>
            <div class="col-sm-4">
                <select v-model="config.svc_sensor_movimento" class="form-control" id="svc_sensor_movimento">
                    <option :value="0">DESABILITAR</option>
                    <option :value="1">MOVIMENTO</option>
                    <option :value="2">CHOQUE</option>
                    <option :value="3">MOVIMENTO + CHOQUE</option>
                    <option :value="4">COLISÃO</option>
                    <option :value="5">MOVIMENTO + COLISÃO</option>
                    <option :value="6">CHOQUE + COLISÃO</option>
                    <option :value="7">HABILITAR TODOS</option>
                </select>
            </div>

            <label for="svc_sensor_movimento" class="col-sm-2 control-label">SLEEP:</label>
            <div class="col-sm-4">
                <select v-model="config.svc_sleep" class="form-control" id="svc_sleep">
                    <option :value="0">DESABILITAR</option>
                    <option :value="1">ULTRA BAIXO CONSUMO DE ENERGIA</option>
                    <option :value="2">BAIXO CONSUMO DE ENERGIA</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="svc_parking_lock" class="col-sm-2 control-label">CHECAR MOV. INDEVIDO:</label>
            <div class="col-sm-2">
                <select v-model="config.svc_parking_lock" class="form-control" id="svc_parking_lock">
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
            <label for="svc_group_send" class="col-sm-2 control-label">POSIÇÕES AGRUPADAS:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_group_send"  class="form-control" id="svc_group_send" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
            <label for="svc_alarm_bateria_principal" class="col-sm-2 control-label">CHECAR BAT. PRINCIPAL:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_alarm_bateria_principal"  class="form-control" id="svc_alarm_bateria_principal" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="svc_zip" class="col-sm-2 control-label">ZIP:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_zip"  class="form-control" id="svc_zip" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
            <label for="svc_alarm_bateria_interna" class="col-sm-2 control-label">CHECAR BAT. INTERNA:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_alarm_bateria_interna"  class="form-control" id="svc_alarm_bateria_interna" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
            <label for="svc_alarm_antena_gps" class="col-sm-2 control-label">CHECAR ANTENA GPS:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_alarm_antena_gps"  class="form-control" id="svc_alarm_antena_gps" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="svc_chamadas" class="col-sm-2 control-label">CHAMADA DE VOZ:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_chamadas"  class="form-control" id="svc_chamadas" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
            <label for="svc_cerca_eletronica" class="col-sm-2 control-label">CERCA ELETRÔNICA:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_cerca_eletronica"  class="form-control" id="svc_cerca_eletronica" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
            <label for="svc_log" class="col-sm-2 control-label">LOG POR SERIAL:</label>
            <div class="col-sm-2">
                <select v-model.number="config.svc_log"  class="form-control" id="svc_log" >
                    <option :value="0">Desabilitar</option>
                    <option :value="1">Habilitar</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-4">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>

            <div class="col-sm-4">

            </div>
            <div class="col-sm-2">
                <!--
                <div class="dropup">
                    <button class="btn btn-xs btn-block btn-default dropdown-toggle" type="button" id="dropdownMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-list-alt"></i> AÇÕES
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuList">
                        <li>
                            <button @click="sendAll()" type="button" class="btn btn-xs btn-success">
                                <i class="fa fa-save"></i> ENVIAR COMANDOS PARA TODOS
                            </button>
                        </li>
                    </ul>
                </div>
                -->
            </div>
        </div>
    </form>
</template>
<script>
    import {Suntech} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "ServicosSuntech",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendServicos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },

            sendAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração para todos?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendServicosAll(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
